import {fetchTemplate, templateQueryKey} from '@github-ui/issue-create/fetch-template'
import {getSelectedTemplate} from '@github-ui/issue-create/use-handle-template-change'
import {useQuery} from '@github-ui/react-query'

export function useDraftIssueFormTemplateQuery({
  owner,
  repo,
  filename,
}: {
  owner: string
  repo: string
  filename: string
}) {
  return useQuery({
    queryKey: templateQueryKey(owner, repo, filename),
    queryFn: async ({signal}) => {
      if (!owner || !repo || !filename) {
        return null
      }

      return fetchTemplate(owner, repo, filename, signal)
    },
    select: repository => (repository ? (getSelectedTemplate(repository) ?? null) : null),
  })
}
